/* Month helpers — designs/monthly-allocations.md M1. Pure "YYYY-MM" string
   math: lexicographic order is chronological order, and no Date parsing
   means no timezone ambiguity. */

export const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

const MONTH_NAMES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
] as const;

const parts = (month: string): [number, number] => {
  const [y, m] = month.split("-");
  return [Number(y), Number(m)];
};

export function monthAdd(month: string, n: number): string {
  const [y, m] = parts(month);
  const total = y * 12 + (m - 1) + n;
  /* the year stays four digits so every result is itself a valid month */
  return `${String(Math.floor(total / 12)).padStart(4, "0")}-${String((total % 12) + 1).padStart(2, "0")}`;
}

/* Inclusive from..to; inverted or malformed bounds are empty. The MONTH_RE
   guard also pins both years to four digits, which is what makes the
   lexicographic <= below chronological — and the loop bounded. */
export function monthRange(from: string, to: string): string[] {
  if (!MONTH_RE.test(from) || !MONTH_RE.test(to)) return [];
  const range: string[] = [];
  for (let m = from; m <= to; m = monthAdd(m, 1)) range.push(m);
  return range;
}

export const fmtMonth = (month: string): string => {
  const [y, m] = parts(month);
  return `${MONTH_NAMES[m - 1]} ${y}`;
};
